import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import ForgotPassword from "./component";
import { forgotPassword, saveLoginAttemptAndForgotPassword } from "./actions";

const mapStateToProps = ({ funnelStep }) => ({
  funnelStep,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      forgotPasswordConnect: forgotPassword,
      saveLoginAttemptAndForgotPasswordConnect: saveLoginAttemptAndForgotPassword,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
